import {NgModule} from '@angular/core'
import {MessagePipe} from '../shared/pipes/msg.pipe'
import {KeysPipe} from '../shared/pipes/keys.pipe'
import {FormStateComponent} from './form-state/form-state.component'
import {AutofocusDirective} from './pipes/autofocus.cp'
import {CommonModule} from '@angular/common'
import {MaterialModule} from './material.module'
import {DragulaModule} from 'ng2-dragula'

@NgModule({
  declarations: [
    MessagePipe,
    KeysPipe,
    FormStateComponent,
    AutofocusDirective,
  ],
  imports: [
    CommonModule,
    MaterialModule,
  ],
  exports: [
    MaterialModule,
    CommonModule,
    MessagePipe,
    KeysPipe,
    FormStateComponent,
    AutofocusDirective,
    DragulaModule,
  ],
})
export class SharedModule {
}
